export const createInvitedSchedulerFilters = (set, get) => ({
    invitedSchedulerFilters: {
        searchName: undefined,
        userType: undefined,
    },
    setInvitedSchedulerFilters: (newFilter) =>
        set((state) => ({
            invitedSchedulerFilters: {
                ...state.invitedSchedulerFilters,
                ...newFilter,
            },
        })),
});



// WEBPACK FOOTER //
// ./src/store/slices/InvitedSchedulerSlice/invitedSchedulerSlice.js